import { ResourceBaseFragment } from '@/graphql/fragments/resource';
import { gql } from '@apollo/client';

export const QUERY_FETCH_RESOURCES_BY_IDS = gql`
  query fetchResourcesByIds($ids: [ID]) {
    resources(sort: "createdAt:desc", filters: { id: { in: $ids } }) {
      data {
        id
        attributes {
          ...ResourceBaseFragment
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;
